import { render, staticRenderFns } from "./Diplomes.vue?vue&type=template&id=53d21edf"
import script from "./Diplomes.vue?vue&type=script&lang=js"
export * from "./Diplomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports